
function animation($css) {
  function enter(element, done) {
    return $css(element, {
      from: { opacity: 0, transform: 'scale(0)' },
      to: { opacity: 1, transform: 'scale(1)' },
      duration: 0.125,
      easing: 'ease-out'
    })
    .start()
    .then(done);
  }

  function leave(element, done) {
    done();
  }

  return { leave: leave, enter: enter };
}

animation.$inject = ['$animateCss'];

export default animation;
